// extracted by mini-css-extract-plugin
export default {"cell":"cell_cell__mK2rh"};